/* TEMA AERIS – caroselli trascinabili col mouse (le liste "slider" delle sezioni
   e la fila di bollini delle collezioni) */
(function () {
  /* stile dei bollini delle collezioni: manina per trascinare e sfumatura sui bordi */
  if (!document.getElementById('aeris-drag-style')) {
    var st = document.createElement('style');
    st.id = 'aeris-drag-style';
    st.textContent = [
      '.aeris-colnav__circles { cursor: grab; }',
      '.aeris-colnav__circles.is-grabbing { cursor: grabbing; user-select: none; }',
      '.aeris-colnav__circles.is-grabbing a, .aeris-colnav__circles.is-grabbing img { pointer-events: none; }',
      '.aeris-colnav__circles img { -webkit-user-drag: none; }',
      '.aeris-colnav__circles.has-more-right { -webkit-mask-image: linear-gradient(to right, #000 calc(100% - 10rem), transparent); mask-image: linear-gradient(to right, #000 calc(100% - 10rem), transparent); }',
      '.aeris-colnav__circles.has-more-left { -webkit-mask-image: linear-gradient(to right, transparent, #000 10rem); mask-image: linear-gradient(to right, transparent, #000 10rem); }',
      '.aeris-colnav__circles.has-more-left.has-more-right { -webkit-mask-image: linear-gradient(to right, transparent, #000 10rem, #000 calc(100% - 10rem), transparent); mask-image: linear-gradient(to right, transparent, #000 10rem, #000 calc(100% - 10rem), transparent); }'
    ].join('\n');
    document.head.appendChild(st);
  }
  function edges(el) {
    var max = el.scrollWidth - el.clientWidth;
    el.classList.toggle('has-more-left', el.scrollLeft > 4);
    el.classList.toggle('has-more-right', el.scrollLeft < max - 4);
  }
  function init(el) {
    if (el.dataset.aerisDrag) return;
    el.dataset.aerisDrag = '1';
    var down = false, moved = false, startX = 0, startScroll = 0;
    el.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      down = true; moved = false;
      startX = e.clientX; startScroll = el.scrollLeft;
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) > 5) { moved = true; el.classList.add('is-grabbing'); }
      if (moved) el.scrollLeft = startScroll - dx;
    });
    window.addEventListener('pointerup', function () {
      if (!down) return;
      down = false;
      el.classList.remove('is-grabbing');
    });
    el.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);
    el.addEventListener('dragstart', function (e) { e.preventDefault(); });
    if (el.classList.contains('aeris-colnav__circles')) {
      el.addEventListener('scroll', function () { edges(el); }, { passive: true });
      window.addEventListener('resize', function () { edges(el); });
      /* il bollino della collezione aperta resta visibile */
      var cur = el.querySelector('.is-current');
      if (cur) {
        var r = cur.getBoundingClientRect(), er = el.getBoundingClientRect();
        if (r.right > er.right) el.scrollLeft += r.left - er.left - er.width / 2 + r.width / 2;
      }
      edges(el);
    }
  }
  function scan() {
    document.querySelectorAll('#MainContent .slider--desktop, #MainContent .aeris-colnav__circles').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  document.addEventListener('shopify:section:load', scan);
})();
